<template>
  <div>
    <div class="animates-items mb16 verticallyCenter">
      <span class="label mr16">滚动到</span>
      <div class="flex1 rectTreeWrap">
        <div class="rect-tree-inp">
          <input
            class="selected-rect"
            type="text"
            readonly
            :value="animateDataVal.componentName"
            @click="showRectTree = !showRectTree"
          />
          <span :class="showRectTree ? 'icon-portal-arrows-down rotate180' : 'icon-portal-arrows-down'"></span>
        </div>
        <chooseComponent
          class="rectTree"
          v-show="showRectTree"
          :responseRectIds.sync="animateDataVal.passiveIds"
          :innerElementLabel.sync="animateDataVal.componentName"
          :showRadio="true"
          :checkedIds="animateDataVal.variable.target"
        />
      </div>
    </div>
    <div class="animates-items">
      <slider-and-input
        class="mb16"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateDataVal.animateDuration"
        title="持续"
        titlePosition="allInOneLine"
        :sliderMax="10000"
        suffix="ms"
      />
      <slider-and-input
        class="mb16"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateDataVal.animateDelay"
        title="延迟"
        titlePosition="allInOneLine"
        :sliderMax="10000"
        suffix="ms"
      />
      <div class="verticallyCenter">
        <div class="mr16">触发</div>
        <div class="content">
          <el-radio-group v-model="animateDataVal.animationIterationCount">
            <el-radio
              v-for="(option, index) in triggerstyles.list"
              :key="index"
              :label="option.value"
              :disabled="option.disabled"
              >{{ option.title }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chooseComponent from "../chooseComponent"
export default {
  name: "fontSize-setting",
  components: { chooseComponent },
  props: {
    animateData: {
      type: Object
    }
  },
  data() {
    return {
      showRectTree: false,
      triggerstyles: {
        type: "触发次数",
        checked: "单次触发",
        list: [
          {
            value: 1,
            disabled: false,
            title: "单次触发"
          },
          {
            value: 2,
            disabled: false,
            title: "多次触发"
          }
        ]
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    animateDataVal: {
      get() {
        return this.animateData
      },
      set(newVal) {
        this.$emit("update:animateData", newVal)
      }
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.selected-rect {
  padding: 0 30px 0 12px;
  background: #f3f3f3;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.8);
  line-height: 32px;
  width: 100%;
  cursor: pointer;
  box-sizing: border-box;
}
.rectTreeWrap {
  position: relative;
  z-index: 9999;
  .rectTree {
    position: absolute;
    top: 32px;
    left: 0;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 6px 24px rgba(31, 35, 41, 0.1);
    padding: 8px;
    box-sizing: border-box;
    z-index: 2;
  }
}
.rect-tree-inp {
  position: relative;
  .icon-portal-arrows-down {
    position: absolute;
    right: 8px;
    top: 8px;
    font-size: 16px;
    pointer-events: none;
    cursor: pointer;
    transition: all 0.5s;
  }
  .rotate180 {
    transform: rotate(180deg);
  }
}
::v-deep .animates-items .el-radio {
  margin-right: 0;
}
</style>
